import {Component} from '@angular/core';

@Component({
  selector: 'ld-tooltip-header',
  templateUrl: 'tooltip-header.template.html',
  styleUrls: [ './tooltip-header.style.scss' ]
})
export class TooltipHeaderComponent {
}
